import {useMutation} from "@apollo/client";
import {AddCredentialDocument} from "generated/graphql";

export const useAddCredential = () => useMutation(AddCredentialDocument);